import type { ReactNode } from 'react';
import { classes } from '@src/components/layout/space';
import { testIdAttr } from '@src/components/testId';
import './Columns.css';

export type ColumnsCount = 2 | 3 | 4 | 'fill' | 'meta';

export interface ColumnsProps {
  children: ReactNode;
  /**
   * 2 — two equal columns, one on narrow.
   * 4 — four on wide, two on mid, one on narrow (My games).
   * fill — as many `--layout-column-narrow` tracks as fit.
   * meta — 15rem | 1fr, stacks on narrow (a catalog row).
   */
  columns?: ColumnsCount;
  gap?: 2 | 3 | 4 | 5 | 6;
  /**
   * On `columns={2}`, a leftover last card stretches the full row. No-op on
   * fill / meta, and on narrow where the grid is already one track.
   */
  wideLast?: boolean;
  className?: string;
  testId?: string;
}

export function Columns({
  children,
  columns = 'fill',
  gap = 5,
  wideLast = false,
  className,
  testId,
}: ColumnsProps) {
  return (
    <div
      className={classes(
        'columns',
        `columns--${columns}`,
        `columns--gap-${gap}`,
        wideLast && 'columns--wide-last',
        className,
      )}
      {...testIdAttr(testId)}
    >
      {children}
    </div>
  );
}
